/**
 * 新增修改客户信息
 */
import React, { Component } from 'react';
import { Modal, Form, Input, DatePicker, TreeSelect, Divider, Row, Col, Select, Table, Button,InputNumber} from 'antd';
import moment from 'moment';
import DictSelect from '../../ui/DictSelect';
import validator from '../../../util/validator';
import Loading from '../../ui/Loading';
import OrgSelect from '../../ui/OrgSelect';

import http from '../../../axios/http';
import messager from '../../ui/messager';

import Image from '../../ui/Image';
//客户拜访记录
import ClientInteractionEdit from './ClientInteractionEdit';
import Scanner from '../../ui/Scanner';

//联络信息
const fields = [{
    "text": "意向客户公司",
    "field": "name",
    rules: [
        { required: true, message: '客户名不能为空!' },
    ]
}
,{
    "text": "客户联系人",
    "field": "contactMan",
    rules: [
        { required: true, message: '客户联系人不能为空!' },
    ]
}
,{
    "text": "电话号码",
    "field": "contactNumber",
    rules: [
        { required: true, message: '电话不能为空' },
        validator.tel
    ]
}
,{
    "text": "意向面积",
    "field": "area",
    number: true,
    rules: [
        { required: true, message: '意向面积不能为空!' },
    ]
}
,{
    "text": "意向楼层",
    "field": "floor",
    "select": true,
    category: "MARKET_CLIENT_FLOOR",
    rules: [
        { required: true, message: '意向楼层不能为空!' },
    ]
}
,{
    "text": "客户来源",
    "field": "customerSource",
    rules: [
        { required: true, message: '客户来源不能为空!' },
    ]
}
,{
    "text": "目前状态",
    "field": "status",
    "select": true,
    category: "MARKET_CLIENT_FOLLOW_STATUS",
    rules: [
        { required: true, message: '目前状态不能为空!' },
    ]
}
,{
    "text": "建档日期",
    "field": "createDate",
    "date": true,
    rules: [
        { required: true, message: '建档日期不能为空!' },
    ]
}
,{
    "text": "商家级别",
    "field": "level",
    "select": true,
    category: "MARKET_CLIENT_LEVEL",
}
,{
    "text": "合作项目",
    "field": "project",
    "select": true,
    category: "market_client_project"
}

,{
    "text": "公司性质",
    "field": "industry",
    "select": true,
    category: "MARKET_CLIENT_INDUSTRY"
}
, {
    "text": "职务",
    "field": "jobTitle"
}
,{
    "text": "品类",
    "field": "type",
    "select": true,
    category: "MARKET_CLIENT_TYPE"
}
,{
    "text": "细分业态",
    "field": "typeDetail",
    "subSelect": true,
}
,{
    "text": "跟进人",
    "field": "creator"
}

,{
    "text": "备注",
    "field": "remarks",
    "textarea": true
}
];

//品牌信息
const brandField = [
    {
        "text": "店名",
        "field": "shopName",
        rules: [
            { required: true, message: '店名不能为空!' },
        ]
    }
    , {
        "text": "主营车类",
        "field": "mainModels"

    }
    , {
        "text": "店铺面积",
        "field": "shopArea"

    }
    , {
        "text": "门店数",
        "field": "shopNum"

    }
    , {
        "text": "月销售额",
        "field": "monthlySales"

    }
    , {
        "text": "月销售单数",
        "field": "monthlySalesNum"

    }
    , {
        "text": "车辆均价",
        "field": "averagePrice"

    }
    , {
        "text": "员工数",
        "field": "employeeCount"

    }];

const columns = [
    {
        title: '拜访时间',
        dataIndex: 'interactionDate',
        width: '35%',
    }
    ,{
        title: '登记人',
        dataIndex: 'creator',
        width: '15%',
    }
    ,{
        title: '拜访记录',
        dataIndex: 'remarks',
        width: '50%',
    }
];


class ClientInfoEditForm extends Component {

    state = {
        activeKey: 'client',
        visible: false,
        dictSelect: {},
        showAgent: true,
        loading: false,
        berthIdsTree: [],
        berthInfo: {},
        surveyImage: [],
        surveyImagesUrl: [],
        buildingList: [],
        typeDetail: "",
        subDictList: [],
        dictList: [],
        interactionVisible: false,
        clientInteractionList: []
    }

    componentDidMount() {
        this.props.initTypeDict(this.initTypeDict);
        http.post({
            url: '/dict/findDict',
            data: { category: 'MARKET_CLIENT_TYPE_DETAIL' },
            success: (res) => {
                res=res==null?[]:res;
                this.setState({ dictList: res });
            }
        });
        http.get({
            url: "/berth/findBuilding",
            success: (res) => {
                let buildingList = res == null ? [] : res;
                this.setState({ buildingList: buildingList });

            }
        });
    }

    componentWillReceiveProps(props) {
        if (props.visible) {
            let surveyImages = props.editData.surveyImagesList;
            let surveyImagesUrl = [];
            let surveyImage = [];
            if (surveyImages != null && surveyImages.length > 0) {
                for (let index in surveyImages) {
                    if (surveyImages[index] != null && surveyImages[index] !== "") {
                        surveyImage.push("data:image/jpeg;base64," + surveyImages[index].replace(/\r\n/g, ""));
                    }
                }
                surveyImagesUrl = props.editData.surveyImagesUrl;
            }
            this.setState({ surveyImage: surveyImage, surveyImagesUrl: surveyImagesUrl, clientInteractionList: props.editData.clientInteractionList });
        }
    }

    initTypeDict = (type) => {
        //修改经营业态
        if (type) {
            let subDictList = [];
            let dictList = this.state.dictList;
            for (let i in dictList) {
                if (dictList[i].des === type) {
                    subDictList.push(dictList[i]);
                }
            }
            this.setState({ subDictList: subDictList })
        }
        else {
            this.setState({ subDictList: [] })
        }
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id;
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            if (values["createDate"] != null) {
                values["createDate"] = values["createDate"].format("YYYY-MM-DD");
            }

            let surveyImages = [];
            let surveyImage = this.state.surveyImage;
            let surveyImagesUrl = this.state.surveyImagesUrl;
            for (let i = 0; i < this.state.surveyImage.length; i++) {
                if (surveyImagesUrl.length > i && surveyImagesUrl[i] != null && surveyImagesUrl[i] !== "") {
                    surveyImages.push(surveyImagesUrl[i]);
                } else {
                    surveyImages.push(surveyImage[i]);
                }
            }
            values["surveyImages"] = JSON.stringify(surveyImages);

            this.setState({ loadingVisible: true });
            values["id"] = this.props.editData.id;
            http.post({
                url: '/market/client/save',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };

    createDom = (data) => {
        let dom = this.createDomItem(data);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    };

    dictSelect = (field, dict, e) => {
        if (field === 'type') {
            let subDictList = [];
            let dictList = this.state.dictList;
            for (let i in dictList) {
                if (dictList[i].des === dict["code"]) {
                    subDictList.push(dictList[i]);
                }
            }
            this.setState({ subDictList: subDictList })
        }
    }

    createDomItem = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                : item.radio ? editData[item.field] === 1
                                    : editData[item.field],

                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.number ?<InputNumber precision={0} min={1} max={9999} style={{ width: '100%' }} />
                                :item.date ? <DatePicker style={{ width: '100%' }} />
                                    : item.select ? <DictSelect category={item.category} onSelect={this.dictSelect.bind(this, item.field)} />
                                        : item.subSelect ? <Select >{this.state.subDictList.map(d => <Select.Option key={d["code"]}> {d["name"]} </Select.Option>)}</Select>
                                            : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                                : item.berthIds ? <TreeSelect multiple={true} treeData={this.state.berthIdsTree} treeDefaultExpandAll={true} showSearch={false} onChange={this.berthOnChange} />
                                                    : item.org ? <OrgSelect orgType={4} />
                                                        : <Input disabled={item.disabled} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    afterClose = () => {
        this.props.form.resetFields();
    }

    hiddenModal = () => {
        this.setState({ visible: false });
    };

    hiddenInteraction = () => {
        this.setState({ interactionVisible: false });
    }

    showModal = (field) => {
        this.setState({ visible: true });
        this.state.initScanner();
    };

    handleUploadImage = (field, { base64 }) => {
        const list = this.state.surveyImage;
        list.push(base64);
        this.setState({ "surveyImage": list });
    }

    handleRemoveImage = (field, index) => {
        const list = this.state.surveyImage;
        const surveyImagesUrl = this.state.surveyImagesUrl;
        list.splice(index, 1);
        surveyImagesUrl.splice(index, 1);
        this.setState({ "surveyImage": list, "surveyImagesUrl": surveyImagesUrl });
    }

    createOtherImageDom = () => {
        let dom = [];
        let data = this.state.surveyImage;
        let surveyImagesUrl = this.state.surveyImagesUrl;
        for (let i = 0; i <= data.length && i < 6; i++) {
            let file = data[i];
            let url = i < surveyImagesUrl.length ? surveyImagesUrl[i] : null;
            dom.push(
                <Col span={4} key={i} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, "surveyImage")}
                        onChange={this.handleUploadImage.bind(this, "surveyImage")}
                        onRemove={this.handleRemoveImage.bind(this, "surveyImage", i)}
                        file={file}
                        text={''}
                        url={url}
                    />
                </Col>
            );
        }
        return dom;
    }

    showClientInteractionModel = () => {
        this.setState({interactionVisible: true, clientInteractionList: this.props.editData.clientInteractionList })
    }

    addInteractionList = (data) => {
        this.setState({ loadingVisible: true });
        let id = this.props.editData.id;
        http.get({
            url: '/market/client/' + id,
            success: (res) => {
                this.setState({ clientInteractionList: res.clientInteractionList,loadingVisible: false });
            },
            error: () => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        const { visible, onCancel, editData} = this.props;
        const clientInteractionList = this.state.clientInteractionList;
        return (
            <Modal
                width={1000}
                visible={visible}
                title="客户信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={this.afterClose}
                footer={[
                    <Button key="addInteraction" type="primary" onClick={this.showClientInteractionModel}>增加拜访记录</Button>,
                    <Button key="save" type="primary" onClick={this.save}>保存</Button>,
                    <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                ]}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <Row>
                        <Divider orientation="left" style={{ marginTop: 0 }}>联络信息</Divider>
                        {this.createDom(fields)}
                    </Row>
                    <Row>
                        <Divider orientation="left" style={{ marginTop: 0 }}>品牌信息</Divider>
                        {this.createDom(brandField)}
                    </Row>
                    <Row>
                        <Divider orientation="left">照片上传</Divider>
                        {this.createOtherImageDom()}
                    </Row>
                    <Divider orientation="left">客户拜访记录</Divider>
                    <Row>
                        <Table rowKey="id" columns={columns} dataSource={clientInteractionList} pagination={{ pageSize: 5 }} />
                    </Row>
                </Form>
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
                <ClientInteractionEdit
                    visible={this.state.interactionVisible}
                    onCancel={this.hiddenInteraction.bind(this)}
                    editData={editData}
                    clientInteractionList={this.state.clientInteractionList}
                    onSuccessCallback={this.addInteractionList.bind(this)}
                />
                <Scanner
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    initScanner={(func) => { this.setState({ initScanner: func }) }}
                    onScan={this.handleScan}
                // successCallback={}
                />
            </Modal>
        );
    }
}

const ClientInfoEdit = Form.create()(ClientInfoEditForm);

export default ClientInfoEdit;